<section *ngIf="createActivityForm && !showImport" class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 text-end">
              <a
                ><button type="button" class="btn-actvtytp" (click)="showImport = !showImport">BULK IMPORT</button></a
              >
            </div>

            <div class="col-md-12 mb-2 empl-tptxt">
              <h3>New Activity</h3>
            </div>
            <div class="col-12 col-md-6">
              <form [formGroup]="createActivityForm">
                <div class="row">
                  <div class="col-12 col-md-12">
                    <app-category-selector
                      [module]="module"
                      (categorySelectorEvent)="onCategorySelected($event)"></app-category-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="name" class="form-label">Activity Name <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Activity Name Select"
                        formControlName="name"
                        [ngClass]="{ 'is-invalid': f[NAME_CONTROL_NAME].errors && f[NAME_CONTROL_NAME].touched }"
                        (change)="onActivityNameSelectChange($event.target.value)">
                        <option [disabled]="true" selected value="">Select Name</option>
                        <option *ngFor="let activityTaskType of activityTaskTypes" value="{{ activityTaskType?.code }}">
                          {{ activityTaskType?.label }}
                        </option>
                      </select>
                      <app-validation
                        field="name"
                        [form]="createActivityForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select Activity Name'
                        }"></app-validation>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="activityType" class="form-label">Type of Activity <sup>*</sup></label>
                      <select
                        class="form-select"
                        aria-label="Activity Type Select"
                        formControlName="activityType"
                        [ngClass]="{
                          'is-invalid': f[ACTIVITY_TYPE_CONTROL_NAME].errors && f[ACTIVITY_TYPE_CONTROL_NAME].touched
                        }">
                        <option [disabled]="true" selected value="">Select Activity</option>
                        <option *ngFor="let activityType of activityTypes" [value]="activityType">
                          {{ activityType }}
                        </option>
                      </select>
                      <app-validation
                        field="activityType"
                        [form]="createActivityForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly select Activity Type'
                        }"></app-validation>
                    </div>
                  </div>
                  <div
                    class="col-12 col-md-6"
                    *ngIf="createActivityForm && createActivityForm.controls[OWNER_ID_CONTROL_NAME]">
                    <app-employee-selector
                      (selectedValueChange)="handleEmployeeSelectedValue($event)"
                      (selectedEmployee)="handleEmployeeSelected($event)"></app-employee-selector>
                    <app-validation
                      [field]="OWNER_ID_CONTROL_NAME"
                      [form]="createActivityForm"
                      [error]="{
                        required: 'This is a mandatory field, Kindly select Valid Employee'
                      }"></app-validation>
                  </div>
                  <div class="col-12 col-md-6">
                    <app-assign-to-selector
                      [mandatory]="false"
                      (selectedValueChange)="handleAssignToSelectedValue($event)"></app-assign-to-selector>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <app-company-selector
                        (selectedValueChange)="handleCompanySelectedValue($event)"
                        [companyId]="selectedEmployeeCompanyEntityId"></app-company-selector>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mb-3">
                      <label for="responseDueDatetime" class="form-label"
                        >Response Due by <sup *ngIf="selectedTaskType?.responseDueInDays === -1">*</sup></label
                      >
                      <ng-container
                        *ngIf="
                          user?.userType === userType.EMPLOYEE_ADMIN && selectedTaskType?.responseDueInDays != -1;
                          else elseBlock
                        ">
                        <input
                          type="text"
                          class="form-control"
                          [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME" />
                      </ng-container>
                      <ng-template #elseBlock>
                        <input
                          type="date"
                          class="form-control"
                          onFocus="this.showPicker()"
                          [formControlName]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME"
                          [ngClass]="{
                            'is-invalid':
                              f[RESPONSE_DUE_DATE_TIME_CONTROL_NAME].errors &&
                              f[RESPONSE_DUE_DATE_TIME_CONTROL_NAME].touched
                          }" />
                        <app-validation
                          [field]="RESPONSE_DUE_DATE_TIME_CONTROL_NAME"
                          [form]="createActivityForm"
                          [error]="{
                            required: 'This is a mandatory field, Kindly select select Response Due By Date'
                          }"></app-validation>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label">Location <sup>*</sup></label>
                      <select class="form-select" aria-label="Default select example" formControlName="location">
                        <option [disabled]="true" selected value="">Select Location</option>
                        <option *ngFor="let location of locationOptions | keyvalue" [value]="location.key">
                          {{ location.value }}
                        </option>
                      </select>
                      <app-validation
                        field="location"
                        [form]="createActivityForm"
                        [error]="{ required: 'This is a mandatory field, Kindly select location' }">
                      </app-validation>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-12"
                    *ngIf="selectedTaskType?.headcountRequired">
                    <div class="mb-3">
                      <label for="headcount" class="form-label">Headcount</label>
                      <input
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        id="headcount"
                        maxlength="5"
                        formControlName="headcount"
                        [ngClass]="{ 'is-invalid': f['headcount'].errors && f['headcount'].touched }" />
                      <app-validation
                        field="headcount"
                        [form]="createActivityForm"
                        [error]="{
                          maxLength: 'Headcount should not exceed 5 characters.',
                          pattern: 'Headcount should contain numbers only.'
                        }">
                      </app-validation>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <label for="exampleFormControlTextarea1" class="form-label">Description<sup>*</sup></label>
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        formControlName="description"
                        [ngClass]="{ 'is-invalid': f['description'].errors && f['description'].touched }"></textarea>
                      <app-validation
                        field="description"
                        [form]="createActivityForm"
                        [error]="{
                          required: 'This is a mandatory field, Kindly add description',
                          minLength: 'Description should have minimum 5 characters.',
                          maxLength: 'Max 5000 characters allowed'
                        }"></app-validation>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        formControlName="addToCalendar" />
                      <label class="form-check-label" for="flexCheckChecked">Add this activity to my Calendar</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <p>Upload Documents</p>
              <app-multiple-file-selector
                [maxAllowedSizeInMB]="7"
                [enableMultiSelect]="true"
                [allowedTypes]="[
                  'application/pdf',
                  'text/plain',
                  'image/jpeg',
                  'image/png',
                  'application/vnd.ms-excel',
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  'application/msword',
                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  'message/rfc822',
                  'application/vnd.ms-excel.sheet.macroenabled.12'
                ]"
                (chooseFiles)="handleFileInput($event)"
                (removeFiles)="clearSelectedFiles($event)"></app-multiple-file-selector>

              <div id="images-show"></div>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn">
              <button type="button" class="btn-actvtytp" (click)="saveAndExit()">SAVE & EXIT</button>
              <button type="button" class="btn-discard" (click)="exit()">EXIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="!createActivityForm && !showImport" class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 text-end">
              <a><button [hidden]="true" type="button" class="btn-actvtytp"></button></a>
            </div>
            <div class="col-md-12 mb-2 empl-tptxt">
              <h3></h3>
            </div>
            <div class="col-md-12 text-end shimmer-div">
              <div class="lines shine"></div>
              <div class="lines shine"></div>
            </div>
            <div class="col-md-12 mb-2 empl-tptxt shimmer-div">
              <div class="lines shine"></div>
              <div class="lines shine"></div>
            </div>
            <div class="col-12 col-md-6">
              <form>
                <div class="row">
                  <div class="col-12 col-md-12 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12 col-md-6 shimmer-div">
                    <div class="lines shine"></div>
                    <div class="lines shine"></div>
                  </div>
                  <div class="col-12">
                    <div class="mb-3 shimmer-div">
                      <div class="lines shine"></div>
                      <div class="lines shine"></div>
                    </div>
                    <div class="form-check shimmer-div">
                      <div class="lines shine"></div>
                      <div class="lines shine"></div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-12 col-md-6">
              <div class="text-center">
                <div class="shimmer-div">
                  <div class="lines shine"></div>
                  <div class="lines shine"></div>
                </div>
              </div>
              <div class="col-12 mt-3 d-flex justify-content-end shimmer-div">
                <div class="big-photo shine"></div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end acvtypglastbtn shimmer-div">
              <div class="lines shine"></div>
              <div class="lines shine"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div *ngIf="showImport">
  <app-bulk-import
    [showNavBar]="false"
    [showLeftMenu]="false"
    [validator]="importValidator"
    (importClose)="showImport = false"
    [close]="false"></app-bulk-import>
</div>
